module.exports = "/_next/static/images/af8ab22c5cd3804444c98cd9cd0800ee-nu-card-xs@3x.jpg";